export const shareRoute = {
  path: "/shares/:shareToken",
};

export const companyRegisterRoute = {
  path: "/company_register/:token",
};

// canvas routes
export const canvasDocumentRoute = {
  path: `/canvas/:documentId`,
  checkParams: ({ documentId }) => /^D\w{12}$/.test(documentId),
};

export const canvasPreviewableRoute = {
  path: `/canvas/previewable/:previewableId`,
};

export * from "./teamRoutes";
